import React, { useCallback, useState } from 'react'
import { HiMail, HiRefresh } from 'react-icons/hi'
import toast from 'react-hot-toast'
import InviteCodeInput from './InviteCodeInput'
import { fetchLeadCrawlReport, requestPreviewOtp } from '../constants/inviteCode'

const OtpAccessPanel = ({
  email,
  domain,
  onVerified,
  className = '',
  compact = false,
}) => {
  const [isSending, setIsSending] = useState(false)

  const verifyCode = useCallback(
    (code) => fetchLeadCrawlReport(domain, code, email),
    [domain, email],
  )

  const handleResend = async () => {
    setIsSending(true)
    try {
      await requestPreviewOtp(email)
      toast.success('A new access code has been sent to your email.')
    } catch (err) {
      toast.error(err.message || 'Unable to resend access code.')
    } finally {
      setIsSending(false)
    }
  }

  return (
    <div className={className}>
      {!compact && (
        <>
          <div className="flex items-center justify-center gap-2 mb-2">
            <HiMail className="h-6 w-6 text-primary-600 dark:text-primary-400" />
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Check your email
            </h3>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
            We sent a 6-digit code to{' '}
            <span className="font-medium text-gray-800 dark:text-gray-200">{email}</span>.
          </p>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            Enter the code below to view your city discovery report for{' '}
            <span className="font-medium text-gray-800 dark:text-gray-200">{domain}</span>.
          </p>
        </>
      )}

      <InviteCodeInput
        verifyCode={verifyCode}
        onVerified={(code) => onVerified?.({ otp: code, domain, email })}
      />

      <div className="mt-4 text-center">
        <button
          type="button"
          onClick={handleResend}
          disabled={isSending}
          className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <HiRefresh className={`h-4 w-4 ${isSending ? 'animate-spin' : ''}`} />
          {isSending ? 'Sending…' : "Didn't get it? Resend code"}
        </button>
      </div>
    </div>
  )
}

export default OtpAccessPanel
